import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { CollegeService } from '../../services/college.service';
import { ValidationService } from '../../services/validation.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-college-list-page',
  imports: [HeaderComponent, ButtonComponent, FilterByKeyAndValuePipe, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent,DropdownUploadButtonComponent],
  templateUrl: './college-list-page.component.html',
})

export class CollegeListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'School Branch';
  form: FormGroup;
  params: any = {};
  selected_college_ids: any = {}
  items: any = [];
  isSubmitting = false;
  show_menu = false;

  city_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'name', headerName: 'School Branch', filter: true, flex: 2, },
    { field: 'code', headerName: 'School Branch Code', filter: true, flex: 1, },
    { field: 'University.name', headerName: 'School', filter: true, flex: 2, },
    { field: 'City.District.State.country.name', headerName: 'Country', filter: true, flex: 1, },
    { field: 'City.District.State.name', headerName: 'State', filter: true, flex: 1, },
    { field: 'City.name', headerName: 'City', filter: true, flex: 1, },
    { headerName: 'Contact Details', filter: true, flex: 2, valueGetter: (p: any) => [p.data?.contact, p.data?.email].filter(Boolean).join(`, `) },
    { field: 'address', headerName: 'Address', filter: true, flex: 1, },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra' },
    // { column_name: 'Division Name', type: 'link',linked_list: 'division_list',returning_key: 'id', return_as: 'division_id', sample_value: 'Mumbai' },
    { column_name: 'District Name', type: 'link', linked_list: 'district_list', returning_key: 'id', return_as: 'district_id', sample_value: 'Thane' },
    // { column_name: 'Taluka Name', type: 'link',linked_list: 'taluka_list',returning_key: 'id', return_as: 'taluka_id', sample_value: 'Suburban' },
    { column_name: 'City Name', type: 'link', linked_list: 'city_list', returning_key: 'id', return_as: 'city_id', sample_value: 'Mumbai Suburban' },
    { column_name: 'School', type: 'link', linked_list: 'university_list', returning_key: 'id', return_as: 'university_id', sample_value: 'ABC School' },
    { column_name: 'School Branch Name', type: 'text', return_as: 'name', sample_value: 'ABC School Branch', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'School Branch Code', type: 'text', return_as: 'code', sample_value: 'ABC123', is_unique: true, min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, unique_error: 'School Branch code already exists', regex: this.vs.code_pattern },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'abc@gamil.com', skip_validation: true, regex: this.vs.email_pattern },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '2345678901', skip_validation: true, regex: this.vs.contact_pattern, min_length: this.vs.min_length_contact, max_length: this.vs.max_length_contact },
    { column_name: 'Address', type: 'text', return_as: 'address', sample_value: 'gggj', skip_validation: true, regex: this.vs.address_pattern, max_length: this.vs.max_length_address },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_college_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_college_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_college_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.masters_college_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public cs: CollegeService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      // division_id: ['',],
      district_id: ['', [Validators.required]],
      // taluka_id: ['',],
      city_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      email: ['', [Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email),]],
      contact: ['', [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact),]],
      address: ['', [Validators.maxLength(this.vs.max_length_address),]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['country', 'state', 'distric', 'city', 'university', 'program', 'stream']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)

    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.cs.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;

    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_college_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_college_ids = item;
    this.confirmation_disabled_modal?.open();
  }
  open_view_modal(item: any) {
    console.log(item);
    this.selected_college_ids = item || {};
    this.view_modal?.open();
  }
  async delete_college() {
    let res = await this.cs.delete(this.selected_college_ids.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_college_ids = {};
    this.confirmation_delete_modal?.close()
    this.ds.invalidate_dropdown_cache('college');
    await this.get_list(this.params);
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.cs.update(this.selected_college_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('college');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      await this.cs.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('college');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_college_ids = item || {};
    this.form.reset();
    if (this.selected_college_ids && this.selected_college_ids.id) {
      let response = await this.cs.get(item?.id);
      this.selected_college_ids = this.gs.addHierarchyIds({ ...response?.data });
      this.form?.patchValue({ ...this.selected_college_ids });
    } else {
      this.selected_college_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = { ...this.form.value };
      delete form_value.country_id
      delete form_value.state_id
      delete form_value.district_id
      form_value.is_active = true;
      if (this.selected_college_ids && this.selected_college_ids.id) {
        let update_response = await this.cs.update(this.selected_college_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {

        let create_response = await this.cs.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('college');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        contact: item.contact + '',
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.cs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }
}
